import React, { useState } from 'react';
// Hooks do React Router para pegar parâmetros da URL e para navegar
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import GuestLayout from '../../Layouts/GuestLayout';
import { TextField } from '@mui/material';
import SecondaryButton from '../../Components/SecondaryButton';

export default function ResetPassword() {
  // O hook useParams() extrai os parâmetros da URL. Estamos pegando o 'token'.
  const { token } = useParams();
  const navigate = useNavigate();

  // Estados para armazenar os dados do formulário
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');

  // Função para lidar com o envio do formulário
  const handleSubmit = async (event) => {
    event.preventDefault(); // Impede o recarregamento da página

    // Validação simples para verificar se as senhas coincidem
    if (password !== passwordConfirmation) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'As senhas não coincidem!',
        confirmButtonColor: '#d33',
        confirmButtonText: 'Tentar Novamente',
      });
      return; // Para a execução se as senhas não baterem
    }

    try {
      // Faz a requisição POST para a API
      const { data } = await axios.post(
        'https://new.cajuu.app/api/password/reset',
        {
          token, // O token da URL
          email,
          password,
          password_confirmation: passwordConfirmation,
        }
      );

      // Mostra um alerta de sucesso
      await Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: data.message,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK',
      });

      // Redireciona para a página de login após o sucesso
      navigate('/login');
    } catch (err) {
      // Pega a mensagem de erro da resposta da API ou define uma padrão
      const errorMessage =
        err.response?.data?.message ||
        'Ocorreu um erro ao tentar redefinir a senha.';

      // Mostra um alerta de erro
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: errorMessage,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Tentar Novamente',
      });
    }
  };

  return (
    <GuestLayout>
      {/* Cabeçalho da página, similar ao ForgotPassword */}
      <div className="flex w-full justify-center mb-[3rem]">
        <div className="flex flex-col items-center text-3xl tracking-tight text-amber-500 font-semibold">
          <span>Reset Password</span>
          <div className="text-white flex items-center mt-2">
            <img src="/img/cajuu.png" alt="Cajuu Logo" className="w-9 h-9 mr-2" />
            Cajuu<span className="text-[#2f2f2f]/40">.</span>
          </div>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        {/* Campo de Email */}
        <div className="mt-4">
          <TextField
            id="email"
            type="email"
            label="Email"
            focused
            className="w-full"
            color="secondary"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        {/* Campo de Nova Senha */}
        <div className="mt-4">
          <TextField
            id="password"
            type="password"
            label="New Password"
            focused
            className="w-full"
            color="secondary"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        {/* Campo de Confirmação de Senha */}
        <div className="mt-4">
          <TextField
            id="password_confirmation"
            type="password"
            label="Confirm New Password"
            focused
            className="w-full"
            color="secondary"
            value={passwordConfirmation}
            onChange={(e) => setPasswordConfirmation(e.target.value)}
            required
          />
        </div>

        {/* Botão de Envio */}
        <div className="mt-10">
          <SecondaryButton
            type="submit"
            className="bg-amber-500 hover:bg-amber-600 hover:text-white border-none h-[3rem] w-full justify-center transition-transform duration-200 ease-in-out hover:scale-95 active:scale-95"
          >
            Reset Password
          </SecondaryButton>
        </div>
      </form>

      {/* Link para voltar ao Login */}
      <div className="mt-6 text-center">
        <Link
          to="/login"
          className="underline text-sm font-medium text-white hover:text-amber-500"
        >
          Back to Login
        </Link>
      </div>
    </GuestLayout>
  );
}